var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('NewsEditor',{attrs:{"news":_vm.news},on:{"submitted":_vm.createNews}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }